import React, { useState, useEffect, useRef } from "react";
import AnimateHeight from 'react-animate-height';
import { cn } from "../lib/helpers";
import Icon from "./icon";
import LinkElem from "./link";
import { useGlobalState } from './global-context';

import * as styles from "../styles/components/footer-menu-group.module.css";

interface MenuItem {
  _key?: string;
  url?: string;
  text?: string;
  blank?: boolean;
}

interface FooterMenuGroupProps {
  title?: string;
  menu?: MenuItem[];
}

const FooterMenuGroup: React.FC<FooterMenuGroupProps> = ({ title, menu }) => {
  const { isMobile } = useGlobalState();
  const [height, setHeight] = useState(0);

  const handleToggleAc = () => {
    setHeight(height === 0 ? 'auto' : 0);
  }

  if (!menu || menu.length === 0) {
    return null;
  }

  const duration = 400;
  const ease = "cubic-bezier(0.86, 0, 0.07, 1)";

  return (
    <li className={cn("col-lg-4", styles.root)}>
      {title && (
        <button 
          className={cn("body-small", styles.title)}
          onClick={isMobile ? handleToggleAc : undefined}
        >
          {title}<Icon symbol={height === 0 ? "plus" : "minus"} />
        </button>
      )}

      <AnimateHeight
        duration={duration}
        easing={ease}
        height={isMobile ? height : 'auto'}
      >
        <div className={styles.inner}>
          <ul className={styles.menu}>
            {menu.map((node) => (
              <li key={node._key}>
                <LinkElem node={node} theme="white" />
              </li>
            ))}
          </ul>
        </div>
      </AnimateHeight>
    </li>
  );
};

export default FooterMenuGroup;
